import React from 'react';
import {EmptyImage, EmptyImageContainer} from './styles';

export default ({src}) => (
  <EmptyImageContainer>
    <EmptyImage src={src} />
  </EmptyImageContainer>
);
